<script lang="ts">

    import {getContext} from 'svelte';
    import {SANITIZE_HTML_KEY} from '../../../svelte/utils';
    import type {TableRow} from './types';
    import type {SanitizeHtmlFunction} from '../../../svelte/types';
    import {getLocalization} from '../../../svelte/context';

    export let rows: TableRow[];

    const localize = getLocalization();
    const sanitizeHtml: SanitizeHtmlFunction = getContext(SANITIZE_HTML_KEY);

    function isEven(index) {
        return index % 2 === 0;
    }

    function isOdd(index) {
        return !isEven(index);
    }
</script>

<table class="detail-table greenHeaderTable detailTable">
    <thead>
    <tr>
        <td class="nazevPoleHeader">{localize(/* @kp-localization detail.nazevPole */ 'detail.nazevPole')}</td>
        <td class="obsahPoleHeader">{localize(/* @kp-localization detail.obsahPole */ 'detail.obsahPole')}</td>
    </tr>
    </thead>
    <tbody>
    {#each rows as row, index}
        <tr class:odd={isOdd(index)} class:even={isEven(index)}>
            <td>{@html sanitizeHtml(row.columns[0].content)}</td>
            <td class={row.columns[1]?.classesInString}>{@html sanitizeHtml(row.columns[1].content)}</td>
        </tr>
    {/each}
    </tbody>
</table>